const scrollingSlider2 = (container, options) => {
	console.log('scrollingSlider2');

    const $container = $(container);

    const defaults = {
        items: 3,
        dots: true,
        loop: false,
        autoplay: true,
        autoplayTimeout: 6000,
        autoplayHoverPause: true,
        autoplaySpeed: 4000,
        responsive: {

            768 : {
                items: 3
            },  

            480 : {
                items: 2,
            },

            0: {
                items: 1
            }
        },
        count_rearrange: false
    };

    options = Object.assign(defaults, options);

    $container.each(function () {

        let $current_container = $(this);

        if($(window).width() > 576) {
            // console.log('desktop product carousel');

            if(options.count_rearrange) {
                count_rearrange($current_container, options);
            }
            else {
                $current_container.owlCarousel(options);
            }
        }
        else {
            // console.log('mobile product carousel');

            window_width_rearrange($current_container);
        }
    });

    function destroy_owl(owl) {

        // console.log('owl destroy');

        owl.trigger('destroy.owl.carousel').removeClass('owl-loaded');
        owl.find('.owl-stage-outer').children().unwrap();
    }

    function count_rearrange(owl, options) {

        // console.log('count rearrange');

        if(owl.find('.scrolling-item__img').length < 8) {

            destroy_owl(owl);

            let single_image_item = $(document).find('.js-scrolling-item-single-image').eq(0);
            let items = owl.find('.js-scrolling-item-multi-image');

            items.each(function () {
                unwrap_two_items($(this), single_image_item)
            });

            if(owl.find('.scrolling-item').length < 3) {
                owl.addClass('container');
                options.loop = false;
                options.items = 2;
                options.responsive = {

                    1200 : {
                        items: 2
                    },

                    768 : {
                        items: 2
                    },

                    0: {
                        items: 1
                    }
                }
            }

            if(owl.find('.scrolling-item').length < 2) {
                owl.addClass('container');
                options.loop = false;
                options.items = 1;
                options.responsive = {
                    0: {
                        items: 1
                    }
                }
            }

            owl.owlCarousel(options);

            return true;
        }
        else {
            owl.owlCarousel(options);

            return false;
        }
    }

    function window_width_rearrange(owl) {

        // console.log('ww rearrange');

        if($(window).width() <= 576) {

            destroy_owl(owl);

            let single_image_item = $(document).find('.js-scrolling-item-single-image').eq(0);
            let items = owl.find('.js-scrolling-item-multi-image');

            items.each(function () {
                unwrap_two_items($(this), single_image_item)
            });

            owl.owlCarousel(options)
        }
    }

    function unwrap_two_items(item, template) {

        let $this = item;
        let single_image_item_clone = template.clone();
        let new_element = $this.find('.js-multiple-item-container').eq(1).detach();
        let new_el_img = single_image_item_clone.find('.scrolling-item__img');

        new_el_img.after(new_element.find('.js-multiple-item-img'));

        single_image_item_clone.find('.scrolling-item__content')
            .attr('href', new_element.attr('href'))
            .attr('data-fancybox','gallery');

        new_el_img.remove();

        single_image_item_clone.removeClass('.js-scrolling-item-multi-image');
        single_image_item_clone.find('.js-multiple-item-img').removeClass('js-multiple-item-img');
        single_image_item_clone.find('.js-scrolling-item-multi-image').removeClass('js-scrolling-item-multi-image');
        single_image_item_clone.find('.scrolling-item__container--item2').removeClass('scrolling-item__container--item2')

        if(single_image_item_clone.find('.scrolling-item__container').children().length > 0) {
            $this.after(single_image_item_clone);
        }

        $this.removeClass('.js-scrolling-item-multi-image');
        $this.find('.js-multiple-item-img').removeClass('js-multiple-item-img');
        $this.find('.js-scrolling-item-multi-image').removeClass('js-scrolling-item-multi-image');
        $this.find('.scrolling-item__container--item2').removeClass('scrolling-item__container--item2');
    }

};

export default scrollingSlider2;
